"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.textContainsUrl = exports.promisifiedTimeout = exports.clientSideObjectId = exports.truncateMiddle = exports.cleanOutControlCharacters = exports.replaceSpacesAndSpecialCharacters = exports.deleteUndefinedKeys = exports.formatGender = exports.formatName = exports.formatUSD = exports.formatAddress = exports.filterByString = exports.convertToSlug = exports.nameForGroup = exports.parseForUrls = exports.cleanRecurringObject = exports.cleanFileName = exports.formatBoundedAttachmentName = exports.formatStringFromArray = exports.creatorWarningType = exports.stripAwayTrailingChar = exports.toReadableFileSize = exports.stringSortByKey = exports.generateShortCode = exports.generateUUID = exports.isValidEmail = exports.capitalizeFirstLetter = exports.minimizeFacilityName = exports.minimizeCalendarName = exports.makeIdMap = exports.getPrintServiceLabel = exports.parseQueryString = void 0;
var lodash_1 = require("lodash");
// @ts-ignore
var regex_1 = require("../constants/regex");
var tenants_1 = require("../constants/tenants");
// @ts-ignore
var contacts_1 = require("../constants/contacts");
// @ts-ignore
var user_types_1 = __importDefault(require("../constants/user.types"));
// @ts-ignore
var security_util_1 = require("./security.util");
var parseQueryString = function (url) {
    var queryString = url.split('?')[1];
    if (!queryString) {
        return {};
    } // No query string found, return an empty object
    var pairs = queryString.split('&');
    var queryParams = {};
    pairs.forEach(function (pair) {
        var _a = pair.split('='), key = _a[0], value = _a[1];
        queryParams[decodeURIComponent(key)] = decodeURIComponent(value || '');
    });
    return queryParams;
};
exports.parseQueryString = parseQueryString;
var getPrintServiceLabel = function (printServiceType) {
    switch (printServiceType) {
        case tenants_1.PRINT_SERVICES.PORTER_ONE:
            return 'Porter One';
        case tenants_1.PRINT_SERVICES.ACTIVITY_CONNECTIONS:
        default:
            return 'Activity Connection';
    }
};
exports.getPrintServiceLabel = getPrintServiceLabel;
/**
 * A regular expression pattern that matches a file extension in a string.
 *
 * - `\.`: Matches a literal dot (`.`), which is the separator for file extensions.
 * - `[^/.]+`: Matches one or more characters that are not a dot (`.`) or a forward slash (`/`).
 * - `$`: Ensures the match occurs at the end of the string.
 *
 * Is used for identifying and extracting file extensions from file paths or filenames.
 */
var EXTENSION_MATCH = /\.[^/.]+$/;
/**
 * A regular expression to match URLs in a given text.
 *
 * - Matches URLs that start with "http://" or "https://".
 * - Ensures the URL is followed by non-whitespace characters.
 * - Excludes trailing punctuation such as ".", ",", ";", ":", "!", "?", ")", "}", "]".
 *
 * Flags:
 * - `g`: Global search to find all matches in the input.
 * - `i`: Case-insensitive matching.
 *
 * Explanation:
 * - `\b`: Asserts a word boundary to ensure the URL is a standalone word.
 * - `https?`: Matches "http" or "https".
 * - `:\/\/`: Matches "://".
 * - `\S+`: Matches one or more non-whitespace characters.
 * - `(?<![.,;:!?)}\]])`: Negative lookbehind to exclude trailing punctuation.
 */
var URL_REGEX = /\bhttps?:\/\/\S+(?<![.,;:!?)}\]])/gi;
var ATTACHMENT_LENGTH = 15;
var makeIdMap = function (models) {
    return models.reduce(function (result, model) {
        var _a;
        return (__assign(__assign({}, result), (_a = {}, _a[model._id.toString()] = model, _a)));
    }, {});
};
exports.makeIdMap = makeIdMap;
var minimizeCalendarName = function (name) {
    return name.replace(/calendar/gi, '').trim();
};
exports.minimizeCalendarName = minimizeCalendarName;
var minimizeFacilityName = function (name) {
    return name
        .replace(/independent living/gi, 'IL')
        .replace(/memory care/gi, 'MC')
        .replace(/assisted living/gi, 'AL');
};
exports.minimizeFacilityName = minimizeFacilityName;
var capitalizeFirstLetter = function (text) {
    if (!text || !text.length) {
        return text;
    }
    return text.charAt(0).toUpperCase() + text.slice(1);
};
exports.capitalizeFirstLetter = capitalizeFirstLetter;
var isValidEmail = function (email) {
    return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email);
};
exports.isValidEmail = isValidEmail;
var generateUUID = function () {
    var s4 = function () {
        return ((1 + Math.random()) * 0x10000).toString(16).substring(0);
    };
    return [s4(), s4(), s4(), s4()].join('-').replace(/\./g, '');
};
exports.generateUUID = generateUUID;
// generate the UID from two parts
// to ensure the random number provide enough bits.
var generateShortCode = function () {
    // eslint-disable-next-line no-bitwise
    var firstPart = (Math.random() * 46656) | 0;
    // eslint-disable-next-line no-bitwise
    var secondPart = (Math.random() * 46656) | 0;
    var firstString = "000".concat(firstPart.toString(36)).slice(-3);
    var secondString = "000".concat(secondPart.toString(36)).slice(-3);
    return firstString.toLowerCase() + secondString.toLowerCase();
};
exports.generateShortCode = generateShortCode;
var stringSortByKey = function (key) { return function (a, b) {
    var keyA = (a[key] || '').toUpperCase();
    var keyB = (b[key] || '').toUpperCase();
    if (keyA < keyB) {
        return -1;
    }
    if (keyA > keyB) {
        return 1;
    }
    return 0;
}; };
exports.stringSortByKey = stringSortByKey;
var toReadableFileSize = function (size) {
    return size && Number.isInteger(size)
        ? "".concat(Math.round(size / 1000000), "mb")
        : undefined;
};
exports.toReadableFileSize = toReadableFileSize;
var stripAwayTrailingChar = function (string, char) {
    if (string[string.length - 1] === char) {
        return string.substring(0, string.length - 1);
    }
    return string;
};
exports.stripAwayTrailingChar = stripAwayTrailingChar;
var creatorWarningType = function (request, isAnyStaffUser) {
    return isAnyStaffUser && request.creator && !(0, security_util_1.isAnyStaff)(request.creator)
        ? request.creator.type
        : undefined;
};
exports.creatorWarningType = creatorWarningType;
var formatStringFromArray = function (input) {
    var string = input.map(exports.capitalizeFirstLetter).join(', ');
    var i = string.lastIndexOf(',');
    if (i > -1) {
        return "".concat(string.substring(0, i), " and").concat(string.substring(i + 1));
    }
    return string;
};
exports.formatStringFromArray = formatStringFromArray;
var formatBoundedAttachmentName = function (attachment, length) {
    if (length === void 0) { length = ATTACHMENT_LENGTH; }
    var extension = attachment.name.match(EXTENSION_MATCH);
    var attachmentName = attachment.name.replace(EXTENSION_MATCH, '');
    if (attachmentName.length > length) {
        var firstSlice = attachmentName.slice(0, length - 8);
        var lastSlice = attachmentName.slice(attachmentName.length - 5, attachmentName.length);
        attachmentName = "".concat(firstSlice, "...").concat(lastSlice);
    }
    return "".concat(attachmentName).concat(extension);
};
exports.formatBoundedAttachmentName = formatBoundedAttachmentName;
var cleanFileName = function (fileName) {
    if (!fileName) {
        return fileName;
    }
    var invalidCharacters = /[^0-9a-zA-Z\s-_]/g;
    var extension = fileName.match(EXTENSION_MATCH);
    var localFileName = fileName.replace(EXTENSION_MATCH, '');
    var cleanedFilename = localFileName
        .replace(invalidCharacters, '')
        .replace(/\s/g, '-');
    return (cleanedFilename || 'file-name') + (extension || '');
};
exports.cleanFileName = cleanFileName;
var cleanRecurringObject = function (recurring) {
    if (recurring &&
        recurring.startDate &&
        recurring.lastDate &&
        recurring.pattern) {
        return __assign(__assign({}, recurring), { exceptions: recurring.exceptions || [] });
    }
    return undefined;
};
exports.cleanRecurringObject = cleanRecurringObject;
var parseForUrls = function (str) {
    var urls = str.match(URL_REGEX);
    return str.split(URL_REGEX).reduce(function (array, newStr, i, list) {
        var newArray = __spreadArray(__spreadArray([], array, true), [newStr], false);
        if (i === list.length - 1) {
            return newArray;
        }
        if (urls) {
            var url = urls[i];
            return __spreadArray(__spreadArray([], newArray, true), [{ value: url, href: url.trim() }], false);
        }
        return array;
    }, []);
};
exports.parseForUrls = parseForUrls;
var nameForGroup = function (group) {
    if (group === user_types_1.default.enterprise) {
        return 'Enterprise Staff';
    }
    if (group === user_types_1.default.staff) {
        return 'Staff';
    }
    if (group === user_types_1.default.family) {
        return 'Resident Connections';
    }
    if (group === user_types_1.default.resident) {
        return 'Residents';
    }
    if (group === contacts_1.CONTACT_TYPES.community) {
        return 'Community Connections';
    }
    return group;
};
exports.nameForGroup = nameForGroup;
var convertToSlug = function (string) {
    return string
        .toLowerCase()
        .replace(/[^\w ]+/g, '')
        .replace(/ +/g, '-');
};
exports.convertToSlug = convertToSlug;
var filterByString = function (search, fields) { return function (item) {
    return !search ||
        (0, lodash_1.some)(fields.map(function (field) {
            var fieldValue = (0, lodash_1.get)(item, field);
            if ((0, lodash_1.isArray)(fieldValue)) {
                var lowercaseSearch_1 = search.toLowerCase();
                return (0, lodash_1.some)(fieldValue.map(function (value) { return value.toLowerCase().indexOf(lowercaseSearch_1) > -1; }));
            }
            return (fieldValue &&
                fieldValue.toLowerCase().indexOf(search.toLowerCase()) > -1);
        }));
}; };
exports.filterByString = filterByString;
var formatAddress = function (address, singleLine) {
    if (singleLine === void 0) { singleLine = true; }
    if (!address) {
        return undefined;
    }
    var address1 = address.address1, address2 = address.address2, city = address.city, state = address.state, zip = address.zip, country = address.country;
    return [address1, address2, "".concat(city, " ").concat(state, " ").concat(zip), country === null || country === void 0 ? void 0 : country.toUpperCase()]
        .map(function (line) { return (line || '').trim(); })
        .filter(function (line) { return line; })
        .join(singleLine ? ' ' : '\n');
};
exports.formatAddress = formatAddress;
var formatUSD = function (money, options) {
    if (options === void 0) { options = {}; }
    if (!(0, lodash_1.isNumber)(money)) {
        return '--';
    }
    return new Intl.NumberFormat('en-US', __assign({ style: 'currency', currency: 'USD' }, options)).format(money);
};
exports.formatUSD = formatUSD;
var formatName = function (user, _a) {
    var _b = _a === void 0 ? {} : _a, secure = _b.secure;
    if (!user) {
        return '';
    }
    if (user.fullName && !secure) {
        return user.fullName;
    }
    var last = secure ? "".concat(user.lastName.charAt(0), ".") : user.lastName;
    var preferred = user.nickname ? " \"".concat(user.nickname, "\" ") : ' ';
    return "".concat(user.firstName).concat(preferred).concat(last);
};
exports.formatName = formatName;
var formatGender = function (gender) {
    if (gender === 'M') {
        return 'Male';
    }
    if (gender === 'F') {
        return 'Female';
    }
    return '';
};
exports.formatGender = formatGender;
var deleteUndefinedKeys = function (obj) {
    return (0, lodash_1.reduce)(obj, function (newObj, value, key) {
        var _a;
        if (value === undefined) {
            return newObj;
        }
        return __assign(__assign({}, newObj), (_a = {}, _a[key] = value, _a));
    }, {});
};
exports.deleteUndefinedKeys = deleteUndefinedKeys;
var replaceSpacesAndSpecialCharacters = function (string, replaceWith) {
    if (replaceWith === void 0) { replaceWith = '_'; }
    return string
        // eslint-disable-next-line no-useless-escape
        .replace(/[`~!@#$%^&*()_|+\-=?;:'",<>\{\}\[\]\\\/]/gi, replaceWith)
        .replace(/ /g, replaceWith);
};
exports.replaceSpacesAndSpecialCharacters = replaceSpacesAndSpecialCharacters;
var cleanOutControlCharacters = function (string, replacementChar) {
    if (!string || string.length < 1) {
        return '';
    }
    // Replacing all control characters with a space
    // They pretend to be spaces when displayed so let's body snatch them for the good guys
    return string.replace(regex_1.CONTROL_CHARACTER_REGEX, replacementChar);
};
exports.cleanOutControlCharacters = cleanOutControlCharacters;
var truncateMiddle = function (text, maxLength, separator) {
    if (separator === void 0) { separator = '...'; }
    if (text.length <= maxLength) {
        return text;
    }
    var charsToShow = maxLength - separator.length;
    var frontChars = Math.ceil(charsToShow / 2);
    var backChars = Math.floor(charsToShow / 2);
    return (text.substring(0, frontChars) +
        separator +
        text.substring(text.length - backChars));
};
exports.truncateMiddle = truncateMiddle;
var clientSideObjectId = function () {
    var _hex = function (value) { return Math.floor(value).toString(16); };
    return (_hex(Date.now() / 1000) +
        ' '.repeat(16).replace(/./g, function () { return _hex(Math.random() * 16); }));
};
exports.clientSideObjectId = clientSideObjectId;
var promisifiedTimeout = function (inputFunc, timeout) {
    return new Promise(function (resolve) {
        setTimeout(function () {
            resolve(inputFunc());
        }, timeout);
    });
};
exports.promisifiedTimeout = promisifiedTimeout;
var textContainsUrl = function (text) {
    return Boolean(text) && URL_REGEX.test(text);
};
exports.textContainsUrl = textContainsUrl;
